var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListeningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.8C0 8.31958 0 6.07937 0.871948 4.36808C1.63893 2.86278 2.86278 1.63893 4.36808 0.871948C6.07937 0 8.31958 0 12.8 0H14.2C18.6804 0 20.9206 0 22.6319 0.871948C24.1372 1.63893 25.3611 2.86278 26.1281 4.36808C27 6.07937 27 8.31958 27 12.8V14.2C27 18.6804 27 20.9206 26.1281 22.6319C25.3611 24.1372 24.1372 25.3611 22.6319 26.1281C20.9206 27 18.6804 27 14.2 27H12.8C8.31958 27 6.07937 27 4.36808 26.1281C2.86278 25.3611 1.63893 24.1372 0.871948 22.6319C0 20.9206 0 18.6804 0 14.2V12.8Z",
    fill: "#0A0A0A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.025 5.80755C9.24083 6.05297 6.375 9.37005 6.375 13.1621V18.4584C6.375 19.7726 7.43583 20.8334 8.75 20.8334H9.54167C10.4125 20.8334 11.125 20.1209 11.125 19.2501V16.0834C11.125 15.2126 10.4125 14.5001 9.54167 14.5001H7.95833V13.1463C7.95833 10.1063 10.3017 7.46214 13.3338 7.37505C16.4767 7.28797 19.0417 9.79755 19.0417 12.9167V14.5001H17.4583C16.5875 14.5001 15.875 15.2126 15.875 16.0834V19.2501C15.875 20.1209 16.5875 20.8334 17.4583 20.8334H18.25C19.5642 20.8334 20.625 19.7726 20.625 18.4584V12.9167C20.625 8.8238 17.1733 5.53839 13.025 5.80755Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListeningIcon);
export default __webpack_public_path__ + "static/media/listening_icon.913ce8c1ebfac727ea69d2a719607784.svg";
export { ForwardRef as ReactComponent };